import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {FahrberichteActions, FahrberichteMutation} from "@/modules/fahrberichte/store/enums";

@Module
export default class Store extends VuexModule {
    settings = [];
    topics = [];

    // feste Filter-Optionen (Werte als stabile Slugs, Labels über i18n) //
    fahrzeugtypOptions = [
        { value: "cabrio", label: "cms.fahrzeugtypCabrio" },
        { value: "gelaendewagen", label: "cms.fahrzeugtypGelaendewagen" },
        { value: "suv", label: "cms.fahrzeugtypSuv" },
        { value: "kleinwagen", label: "cms.fahrzeugtypKleinwagen" },
        { value: "kombi", label: "cms.fahrzeugtypKombi" },
        { value: "limousine", label: "cms.fahrzeugtypLimousine" },
        { value: "sportwagen", label: "cms.fahrzeugtypSportwagen" },
        { value: "van", label: "cms.fahrzeugtypVan" },
        { value: "andere", label: "cms.fahrzeugtypAndere" }
    ];

    kraftstoffartOptions = [
        { value: "benzin", label: "cms.kraftstoffartBenzin" },
        { value: "diesel", label: "cms.kraftstoffartDiesel" },
        { value: "elektro", label: "cms.kraftstoffartElektro" },
        { value: "hybridDiesel", label: "cms.kraftstoffartHybridDiesel" },
        { value: "hybridBenzin", label: "cms.kraftstoffartHybridBenzin" },
        { value: "pluginHybrid", label: "cms.kraftstoffartPluginHybrid" },
        { value: "andere", label: "cms.kraftstoffartAndere" }
    ];

    get getFahrberichteSettings() {
        return this.settings;
    }

    get getFahrberichteTopics() {
        return this.topics;
    }

    get getFahrberichteFahrzeugtypOptions() {
        return this.fahrzeugtypOptions;
    }

    get getFahrberichteKraftstoffartOptions() {
        return this.kraftstoffartOptions;
    }

    @Mutation
    [FahrberichteMutation.SET_SETTINGS_RESULT](settings) {
        this.settings = settings;
    }

    @Mutation
    [FahrberichteMutation.SET_TOPICS_RESULT](topics) {
        this.topics = topics;
    }

    @Action
    [FahrberichteActions.FETCH_SETTINGS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("content/get-reference-settings/fahrbericht").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(FahrberichteMutation.SET_SETTINGS_RESULT, data.result);
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.CREATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('content/create-reference-setting', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_SETTINGS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.UPDATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            const {settingsId, data: settingData} = payload;

            apiService.put(`content/update-reference-setting/${settingsId}`, settingData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_SETTINGS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.DELETE_SETTING](settingsId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`content/delete-reference-setting/${settingsId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_SETTINGS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.FETCH_TOPICS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("content/get-reference-topics/fahrbericht").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(FahrberichteMutation.SET_TOPICS_RESULT, data.result);
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.CREATE_TOPIC](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('content/create-reference-topic', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.UPDATE_TOPIC](payload) {

        return new Promise((resolve, reject) => {

            const {topicId, data: topicData} = payload;

            apiService.put(`content/update-reference-topic/${topicId}`, topicData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.DELETE_TOPIC](topicId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`content/delete-reference-topic/${topicId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FahrberichteActions.REORDER_TOPICS](payload) {

        return new Promise((resolve, reject) => {

            apiService.put('content/reorder-reference-topics', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FahrberichteActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
